import React from "react";
import PropTypes from "prop-types";

import { Skeleton } from "@material-ui/lab";

import FormFieldList from "scenes/Hubly/components/Workspace/components/FormFieldList";
import useFields from "scenes/Hubly/components/Workspace/components/FormModal/hooks/useFields";
import { AccessTypeProvider } from "scenes/Hubly/components/Workspace/components/hooks/useAccessType";

export function TaskFormInstance({ formId, onClick }) {
  const { task, fields, loading } = useFields(formId);

  if (loading) {
    return (
      <div style={{ marginTop: "1em" }}>
        <Skeleton animation="wave" width="90%" />
        <Skeleton animation="wave" width="75%" />
        <Skeleton animation="wave" width="75%" />
        <Skeleton animation="wave" width="75%" />
      </div>
    );
  }

  return (
    <AccessTypeProvider initState={{ ready: true, readOnly: false }}>
      <FormFieldList
        isFormInstance
        formName={task?.formName}
        fields={fields}
        onClick={onClick}
      />
    </AccessTypeProvider>
  );
}

TaskFormInstance.propTypes = {
  formId: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};

TaskFormInstance.defaultProps = {
  onClick: () => {},
};

export default TaskFormInstance;
